import scBarChart from '../components/ScBarChart'
import httpManager from "../../util/common";
import scTable from '../components/ScTable'
import {entityOaid} from "../../util/util";
import { Upload } from 'ant-design-vue';

let supplier_home = {
  components: {scBarChart, scTable},
  delimiters: ['{', '}'],
  props: {

  },
  data: () => {
    return {
      oaid: null,
      type:'supplier',
      industry: "",
      officialName: "",
      sname: null,
      soaid: null,
      report: null,
      initSname: null,
      defaultId:null
    }
  },
  methods: {
    // 清除按钮
    cleanCondition(){
      this.report = null
      this.sname = null
    },
    recevie(oaid, name, report){
      if(!this.initSname){
        this.initSname = name
        this.initSoaid = oaid
      }
      this.sname = name
      this.soaid = oaid
      this.report = report
    },
    callIndicationTable(){
      let id = this.$route.params.oaid
      let self = this
      entityOaid.oaid(id).then(result => {
        self.oaid =result
      })
    },
  },
  mounted () {
    this.callIndicationTable()
  },
}
export default supplier_home



// WEBPACK FOOTER //
// ./src/supplychain/js/sc_suppliers.js